import { LinkButton, Responsive, useDeviceType } from '@cian/ui-kit';
import * as styles from './styles.css';
import { NBSP } from 'shared/constants/symbols';
import { GUIDE } from 'shared/constants/links';
import { clsx } from 'clsx';
import { caGoToGuide } from '../tracking';

export const FiveSteps: React.FC = () => {
  const device = useDeviceType();

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['textblock']}>
        <div className={styles['subtitle']}>Подробный гайд по посуточной аренде:</div>
        <div className={styles['title']}>5 шагов от объявления до{NBSP}стабильных броней</div>
        <Responsive desktop>
          <div className={styles['btn']}>
            <LinkButton size="L" href={GUIDE} onClick={caGoToGuide} target="_blank" rel="noopener noreferrer">
              Перейти
            </LinkButton>
          </div>
        </Responsive>
      </div>
      <div className={styles['image']} />
      <Responsive tablet phone>
        <div className={styles['btn']}>
          <LinkButton size="L" href={GUIDE} onClick={caGoToGuide} target="_blank" rel="noopener noreferrer">
            Перейти
          </LinkButton>
        </div>
      </Responsive>
    </div>
  );
};
